module.exports = __webpack_public_path__ + "img/bg-total.52578240.jpg";